<template>
  <div
    class="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2"
    :class="isFirst ? 'mt-0':'mt-20'"
  >
    <div class="w-services-item max-w-full">
      <h3 class="text-lg font-regular-bold mb-4">{{ title }}</h3>
      <p class=" font-light"><slot></slot></p>
    </div>
    <div class=" px-32 max-h-full max-w-full">
      <img :src="require('@/assets/images/' + title + '.svg')" :alt="title" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'detail-odd',
  props: ['title', 'isFirst'],
};
</script>
